<template>
  <card-component title="2. ¿CUÁL ES EL NOMBRE DE TU MADRE?" icon="cellphone" :has-card-header-background="true" :has-button-slot="true">
    <form @submit.prevent="submit" method="POST">
      <b-field :label="labelText">
        <b-input v-model="phone" name="phone" validation-message="Ingresa un número de celular válido"
              pattern="^9\d{8}$" required autofocus/>
      </b-field>
      <hr>
      <div class="control">
        <b-button  class="button is-primary" @click="verifyCellphone" >
          Enviar código de verificación
        </b-button>
      </div>
    </form>
  </card-component>
</template>

<script>
import { mapState } from 'vuex'
import CardComponent from '@/components/CardComponent'
import TokenRepository from '@/services/TokenRepository'

export default {
  name: 'EnterPhone',
  components: { CardComponent },
  data () {
    return {
      phoneRegistered: '*********',
      phone: null
    }
  },
  computed: {
    ...mapState([
      'idUser'
    ]),
    labelText () {
      return `Tenemos que verificar tu identidad. Completa tu número de celular ******${this.phoneRegistered ? this.phoneRegistered.toString().substring(6) : ''} para enviarte un código de verificación.`
    }
  },
  mounted () {
    setTimeout(() => {
      TokenRepository.getPhoneNumber(this.idUser)
        .then(r => {
          this.phoneRegistered = r.data.phone_number
        }).catch(e => {
          this.showError(e.response.data.detail)
        })
      console.log(this.phoneRegistered.substring(6))
    }, 500)
  },
  methods: {
    savePhoneNumber () {
      console.log(this.phone)
    },
    verifyCellphone () {
      console.log('se verifica el número')
      // console.log(this.phoneRegistered)
      // console.log(this.phoneRegistered === this.phone)
      if (this.phoneRegistered === this.phone) {
        TokenRepository.requestCodeSMS(this.idUser)
          .then((r) => {
            this.$router.push('/enter-code')
          }).catch(e => {
            this.showError(e.response.data.detail)
          })
      } else {
        this.$buefy.toast.open({
          message: 'No es el celular que registraste',
          type: 'is-danger'
        })
      }
    }
  }
}
</script>
